export default "__VITE_ASSET__LwlY8Zls__"